import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "7a281B4d9VFGYpObgNQHYxH", "WallShake", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Enum, Vec2, v2, v3 } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
export var E_ShakeType;

(function (E_ShakeType) {
  E_ShakeType[E_ShakeType["Wall"] = 0] = "Wall";
  E_ShakeType[E_ShakeType["Wall_Reduce"] = 1] = "Wall_Reduce";
})(E_ShakeType || (E_ShakeType = {}));

var WallShake = (_dec = menu("act/WallShake"), _dec2 = property({
  type: Enum(E_ShakeType)
}), _dec3 = property({
  visible: function visible() {
    return this.type == E_ShakeType.Wall || this.type == E_ShakeType.Wall_Reduce;
  },
  tooltip: "x,y shake range"
}), _dec4 = property({
  visible: function visible() {
    return this.type == E_ShakeType.Wall_Reduce;
  },
  tooltip: "x,y shake range reduce"
}), _dec5 = property({
  visible: function visible() {
    return this.type == E_ShakeType.Wall || this.type == E_ShakeType.Wall_Reduce;
  },
  tooltip: "shake time, while shakeTime == -1, will always shake"
}), ccclass(_class = _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(WallShake, _Component);

  function WallShake() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "type", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "range", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "rangeReduce", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "shakeTime", _descriptor4, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_curShakeTime", 0);

    _defineProperty(_assertThisInitialized(_this), "_curRange", new Vec2());

    _defineProperty(_assertThisInitialized(_this), "_initPos", new Vec2());

    _defineProperty(_assertThisInitialized(_this), "_act", false);

    return _this;
  }

  var _proto = WallShake.prototype;

  // LIFE-CYCLE CALLBACKS:
  // onLoad () {}
  _proto.start = function start() {
    this.range = v2(1, 1);
    this._initPos = v2(this.node.position.x, this.node.position.y);
    this.addEventListener();
  };

  _proto.onDestroy = function onDestroy() {
    this.removeEventListener();
  };

  _proto.addEventListener = function addEventListener() {};

  _proto.removeEventListener = function removeEventListener() {};

  _proto.reset = function reset() {
    this._act = false;
    this.node.setPosition(v3(this._initPos.x, this._initPos.y));
  };

  _proto.shake = function shake() {
    if (this._act) {
      return;
    }

    this._act = true;

    switch (this.type) {
      case E_ShakeType.Wall:
        this.shakeWall();
        break;

      case E_ShakeType.Wall_Reduce:
        this.shakeWall_reduce();
        break;

      default:
        break;
    }
  };

  _proto.shakeWall = function shakeWall() {
    this._curShakeTime = this.shakeTime;
  };

  _proto.shakeWall_reduce = function shakeWall_reduce() {
    this._curShakeTime = this.shakeTime;
    this._curRange = v2(this.range.x, this.range.y);
  };

  _proto.update = function update(dt) {
    if (!this._act) return;

    if (this._curShakeTime > 0 || this._curShakeTime == -1) {
      if (this._curShakeTime != -1) {
        this._curShakeTime -= dt;
      }

      switch (this.type) {
        case E_ShakeType.Wall_Reduce:
          this.up_wall_reduce(dt);
          break;

        case E_ShakeType.Wall:
          this.up_wall(dt);
          break;
      }
    } else {
      this._curRange = v2(0, 0);
      this.node.setPosition(v3(this._initPos.x, this._initPos.y));
      this._curShakeTime = 0;
    }
  };

  _proto.up_wall_reduce = function up_wall_reduce(dt) {
    var minx = this._curRange.x - 1 <= 0 ? 0 : this._curRange.x - 1;
    minx *= Math.random() < 0.5 ? 1 : -1;
    var x_temp = this._initPos.x + Math.random() + minx;
    var miny = this._curRange.y - 1 <= 0 ? 0 : this._curRange.y - 1;
    miny *= Math.random() < 0.5 ? 1 : -1;
    var y_temp = this._initPos.y + Math.random() + miny;
    this.node.setPosition(v3(x_temp, y_temp));
    this._curRange.x -= this.rangeReduce.x;
    this._curRange.y -= this.rangeReduce.y;
  };

  _proto.up_wall = function up_wall(dt) {
    var x = this._initPos.x + Math.random() * this.range.x * 2 - this.range.x;
    var y = this._initPos.y + Math.random() * this.range.y * 2 - this.range.y;
    this.node.setPosition(v3(x, y));
  };

  return WallShake;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return E_ShakeType.Wall;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "range", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new Vec2(6, 6);
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "rangeReduce", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new Vec2(0.1, 0.1);
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "shakeTime", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
})), _class2)) || _class) || _class);
export { WallShake as default };

_cclegacy._RF.pop();